import React, { useEffect } from 'react'
import { Modals } from '../components/modals'
import Support from '../components/chat/support'
import { Drawers } from '../components/drawers'
import { useGeneral } from '../stores/useGeneral'
import { setTheme } from '../utils/helper'
import supportStore from '../stores/useSupport'

const SupportPage = ({dark, light}) =>{
  const {setMode,darkmode } = useGeneral(state=>state)
  const {primaryColor, wallpaper, gradient, pattern, 
    setColor, setPattern, setWallpaper, setGradient
  } = supportStore(state=>state)

  useEffect(()=>{

     if(dark){
      setMode('dark')
      setTheme(
        setColor, setMode, setPattern, setWallpaper, setGradient,
        {darkmode:true, color:'blue', wallpaper:{path:'/images/wallpapers/dark/1.jpg', position:'cover'} })  
     }
     if(light){
      setMode('light')
      setTheme(
        setColor, setMode, setPattern, setWallpaper, setGradient,
        {darkmode:false, color:'green', wallpaper:{path:'/images/livechat/gradient/6.svg', position:'cover'} })
    }

  },[])
  //document.body.setAttribute('data-mode', dark?'dark':'light')
  document.head.querySelector('title').text = 'Neon Hype5 React Chat Platform'
  return (
    <React.Fragment>
        <Support />
        <Modals />
        <Drawers />
    </React.Fragment>
  )
}
export default SupportPage